"use strict";

Fotobook.themeRollerHighlighter = {
    highlightClass: 'theme_roller_highlight',
    excludeVars: ['mainFontFamily', 'mainFontSize', 'colouredText', 'linkColor', 'linkHoverColor', 'linkActiveColor'],
    getAllCssRules() {
        const css = [];

        // честно украдено со stackoverflow (https://stackoverflow.com/a/1679709)
        // не будем кешировать, т.к. у нас SPA, всякие динамические попапы и т.д.
        // мы никогда заранее не знаем, какие элементы в DOM
        for (let sheeti = 0; sheeti < document.styleSheets.length; sheeti++) {
            const sheet = document.styleSheets[sheeti];
            const rules = 'cssRules' in sheet ? sheet.cssRules : sheet.rules;
            for (let rulei = 0; rulei < rules.length; rulei++) {
                const rule = rules[rulei];
                if ('cssText' in rule) {
                    css.push(rule.cssText);
                }/* else {
                    // похоже, это нам не нужно
                    css.push(`${rule.selectorText} {\n${rule.style.cssText}\n}\n`);
                }*/
            }
        }
        return css;
    },
    highlightSelectors(selectors = []) {
        $(selectors.join(',')).addClass(this.highlightClass);
    },
    // можно сделать всё одним циклом, но так удобнее
    processMatches(varNames = []) {
        const css = this.getAllCssRules();

        // регулярка для получения селектора: всё, что левее от набора символов ` {`
        const regExpSelector = /[^{]+/;

        // регулярка для получения CSS правил, использующих переменные:
        // всё, что между наборами символов `var(` и `);`
        // примерный результат: var(--some-var
        const regExpVar = /var([^);]+)/g;

        const selectors = [];
        css.forEach((item) => {
            const matches = item.match(regExpVar);
            if (!matches || !matches.length) {
                return;
            }
            matches.forEach((match) => {
                // отсекаем первые 4 символа `var(`
                const variable = match.substring(4);
                if (!varNames.includes(variable)) {
                    return;
                }

                let selector = item.match(regExpSelector)[0];
                if (!selector) {
                    return;
                }

                // отсекаем ::after и ::before для корректной подсветки некоторых элементов
                selector = selector.replace(/::before|::after/g, '');

                // eslint-disable-next-line no-console
                console.log('[ThemeRoller] highlight:', selector, variable);

                if (selector.includes('@')) { // fix for media queries
                    return;
                }

                // не работает с svg и их дочерними элементами.
                // проверяем каждый селектор на наличие родителя svg и прибиваем класс подсветки именно ему
                const $svgParents = $(selector).parents('svg');
                if ($svgParents.length) {
                    // почему last? первый выбирается в темроллере, его нам не надо
                    $svgParents.last().addClass(this.highlightClass);
                } else {
                    selectors.push(selector);
                }
            });
        });
        this.highlightSelectors(selectors);
    },
    hoverOn($el) {
        const varName = $el.attr('data-var');

        // не подсвечиваем некоторые глобальные стили
        if (!varName || this.excludeVars.includes(varName)) {
            return;
        }
        let cssVarsMap = $(Fotobook.themeRoller.selector).data('css_vars_map') || {};
        const cssVarNames = cssVarsMap[varName];
        if (!cssVarNames) {
            return;
        }
        this.processMatches(cssVarNames);
    },
    hoverOff() {
        $(`.${this.highlightClass}`).removeClass(this.highlightClass);
    },
};
